module.exports = __webpack_public_path__ + "img/documents--avatar.0de835e5.svg";